import { useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { setShowSettings, setSettingsTab } from '../Redux/store';
import { X } from 'lucide-react';
import Tabs from '../components/Tabs';
import ModalWrapper from '../components/ModalWrapper';
import MatchSettings from './Settings/MatchSettings';
import ChatSettings from './Settings/ChatSettings';
import AccountSettings from './Settings/AccountSettings';
import DisplaySettings from './Settings/DisplaySettings';
// NOTE: DeveloperSettings is commented out but should NOT be deleted - keep for future use
// import DeveloperSettings from './Settings/DeveloperSettings';

const TABS = [
  { name: 'match', disabled: false },
  { name: 'chat', disabled: false },
  { name: 'account', disabled: false },
  { name: 'display', disabled: false },
  // NOTE: DeveloperSettings is commented out but should NOT be deleted - keep for future use
  // { name: 'developer', disabled: false },
];

/** Full-screen settings overlay with tabbed content */
function SettingsOverlay() {
  const open = useSelector((s) => s.ui.showSettings);
  const tab = useSelector((s) => s.ui.settingsTab);
  const dispatch = useDispatch();

  // Lock body scroll while open
  useEffect(() => {
    if (!open) return;
    const prev = document.documentElement.style.overflow;
    document.documentElement.style.overflow = 'hidden';
    return () => { document.documentElement.style.overflow = prev; };
  }, [open]);

  if (!open) return null;

  const tabNames = TABS.map(t => t.name);
  const active = tabNames.includes(tab) ? tab : 'match';

  return (
    <ModalWrapper onClose={() => dispatch(setShowSettings(false))}>
      <header className="flex h-14 shrink-0 items-center justify-between border-b border-border px-4">
        <h2 className="text-base font-semibold">Settings</h2>
        <button onClick={() => dispatch(setShowSettings(false))}><X className="h-5 w-5" /></button>
      </header>
      <Tabs tabs={TABS} selectedTab={active} onTabSet={(t) => dispatch(setSettingsTab(t))} />
      <div className="min-h-0 flex-1 overflow-y-auto p-5 scrollbar-hide">
        {active === 'match' && <MatchSettings />}
        {active === 'chat' && <ChatSettings />}
        {active === 'account' && <AccountSettings />}
        {active === 'display' && <DisplaySettings />}
        {/* NOTE: DeveloperSettings is commented out but should NOT be deleted - keep for future use */}
        {/* {active === 'developer' && <DeveloperSettings />} */}
      </div>
    </ModalWrapper>
  );
}

export default SettingsOverlay;
